module.exports = __webpack_public_path__ + "static/media/catat_harian_siswa.ebf74fac.png";